import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ReservationGiftStatus, ReservationGiftStatusDefinition } from 'app/models/reservation-gift-status.model';
import { ReservationGiftStatusService } from 'app/services/loyalty/reservation-gift-status.service';
import { SelectItem } from 'primeng/components/common/api';

@Component({
  selector: 'app-loyalty-reservation-gift-status-form',
  templateUrl: './loyalty-reservation-gift-status-form.component.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})
export class LoyaltyReservationGiftStatusFormComponent implements OnInit {
  @Output() giftStatusAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() giftStatusUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxGiftStatus: ReservationGiftStatus;
  @Input() editMode: boolean;
  addEditForm: FormGroup;
  invalidSubmit: boolean;
  validation: any;
  statusDefinition: SelectItem[];

  constructor(private fb: FormBuilder, private srvGiftStatus: ReservationGiftStatusService) { }

  ngOnInit() {
    this.loadValidation();
    this.loadStatusDefinition();
  }

  /**
   * Carica i campi dal metodo getFields del Servizio ReservationGiftStatusService
   */
  loadValidation(){
    this.srvGiftStatus.getFields().subscribe(res => {
      this.validation = res;
    });
  }

  /**
   * Mi creo i campi del form di aggiunta/modifica
   * @param args 
   */
  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
        'status_initial_id': new FormControl(this.dialogBoxGiftStatus.status_initial_id),
        'status_final_id': new FormControl(this.dialogBoxGiftStatus.status_final_id),
        'action': new FormControl(this.dialogBoxGiftStatus.action)
    });
  }

  /**
   * Metodo per la creazione o modifica di un record
   * @returns 
   */
  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

   let newData = Object.assign({}, this.dialogBoxGiftStatus, this.addEditForm.value);
   if (newData.id == null) {
     this.giftStatusAdded.emit(newData);
   } else {
     this.giftStatusUpdated.emit(newData);
   }
 }

 /**
  * Chiama un metodo del servizio ReservationGiftStatusService per ottenere
  * la lista delle definition e li aggiunge in un array che verrà visualizzato dal dropdown
  */
 loadStatusDefinition() {
  this.srvGiftStatus.listDefinition().subscribe(res => {
    this.statusDefinition = [];
    for (const status of res.data) {
      this.statusDefinition.push({ label: `(${status.description})` , value: status.id });
    }
  });
}


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status-form/loyalty-reservation-gift-status-form.component.ts